import { makeStyles } from '@material-ui/core/styles';

import color from '../../theme/MUI/color';

const useStyles = makeStyles((theme) => ({
  container: {
    background: color.neutral['0'],
    [theme.breakpoints.down('md')]: {
      paddingTop: '0',
    },
  },
  inspectionCheckList: {
    [theme.breakpoints.up('md')]: {
      paddingBottom: `${theme.spacing(9)}px`,
    },
  },
  seoParagraph: {
    [theme.breakpoints.up('md')]: {
      width: '74%',
      margin: 'auto',
    },
  },
}));

export default useStyles;
